<template>
  <div class="circleindex">
    <headd :mobile_title="mobile_title"></headd>
    <div class="kv hidden-sm hidden-xs" @click="createpost">
      <img src="../../../static/circle/kv.png" />
    </div>

    <div class="container">
      <div class="circle_index ">
        <div class="circle_type">
          <div v-for="item in circle_list_hot" :key="item.title">
            <div
              class="type_item"
              @click="getcircleDetail(item.title)"
              :data-id="item.title"
              :style="{
                backgroundImage:
                  'url(' + (item.imgUrl != '' ? item.imgUrl : moren) + ')',
                backgroundSize: '3.7rem 2.04rem'
              }"
            >
              <div class="type_title">#{{ item.title }}#</div>
              <div class="type_desc">
                {{ item.like_num }}喜欢
                <img class="red" src="../../../static/circle/red.png" />
              </div>
            </div>
          </div>

          <div
            @click="getallcircle"
            class="type_item"
            style="background: url(../../static/circle/icon_6.png) no-repeat;background-size: 3.7rem 2.04rem;"
          >
            <div class="type_title">
              全部话题
            </div>
            <div class="type_btn_all"></div>
          </div>
        </div>

        <circlelist :circletrends="circletrends"></circlelist>
        <div class="gomore" @click="morelist" v-show="!flag">加载更多</div>
      </div>
    </div>
    <foot></foot>
    <div class="add hidden-lg hidden-md" @click="createpost">发布</div>
  </div>
</template>

<script>
import circlelist from "../../components/circle-list.vue";
import headd from "@/components/head";
import foot from "@/components/foot";
import { getallCircleTrends, gethotCircleTopic } from "../api/api"; //引入api里面定义的方法
export default {
  data() {
    return {
      mobile_title: "圈子社区",
      circle_list_hot: [],
      circletrends: [],
      pageindexhot: 1,
      pageindex: 1,
      flag: false,
      search: "",
      moren: "../../static/circle/icon_mr.png"
    };
  },
  metaInfo: {
    title: "马上创业网 专注企业注册的网站", // set a title
    meta: [
      {
        // set meta
        name: "keyWords",
        content:
          "马上创业网，注册公司，代理记账，上海注册公司，注册公司流程，注册公司费用，商标注册，法务咨询，法律服务，个体工商户注册，许可证办理，专业法律，社保，公积金，专利申请，医疗器械许可证，ICP电信增值许可证，食品经营许可证，酒类经营许可证，餐饮服务许可证，道路运输许可证，广播电视节目许可证，海关资质，进出口许可证，商标设计，logo设计，VI设计，海报设计，包装设计，APP开发，微信运营，网站定制，版权服务，软件著作权，发明专利，外观设计专利，实用新型专利，商标转让，驳回复审，注销公司，股权变更，经营范围变更，股权协议，股权转让，劳务派遣"
      },
      {
        name: "description",
        content:
          "马上创业网是一个专为中小企业服务的综合平台，主要提供医疗器械服务、审计服务、知识产权服务、财税咨询、注册公司、代理记账、商标注册、专利申请、社保代理、法务代理等一站式的服务，借助移动互联网技术，改善并升级企业服务状态，实现了新形势下中小企业所需要的企业服务。"
      }
    ]
  },
  components: {
    circlelist,
    headd,
    foot
  },
  mounted() {
    this.getCircleHot();
    this.getCircle();
  },
  methods: {
    createpost() {
      this.$router.push({
        path: "createpost"
      });
      //   uni.navigateTo({
      //     url: "createpost"
      //   });
    },
    async getCircleHot() {
      var _slef = this;
      var data = {
        page: _slef.pageindexhot,
        limit: 5
      };
      const res = await gethotCircleTopic(data);
      _slef.circle_list_hot = res.data.data.hottopic;
    },
    async getCircle() {
      var _slef = this;
      var data = {
        search: _slef.search,
        page: _slef.pageindex,
        limit: 10
      };
      const res = await getallCircleTrends(data);
      _slef.circletrends = [
        ..._slef.circletrends,
        ...res.data.data.circletrends
      ];
      // _slef.circletrends = _slef.circletrends.concat(res.data.data.circletrends)
      if (res.data.data.circletrends.length < 10) {
        _slef.flag = true;
      }
    },
    getallcircle() {
      this.$router.push({
        path: "circle"
      });
    },
    getcircleDetail(title) {
      //   var id = e.currentTarget.dataset.id;
      //   uni.navigateTo({
      //     url: "./circle_detail?type=" + id
      //   });
      this.$router.push({
        path: "circle_detail",
        query: {
          type: title
        }
      });
    },
    getsearch(value) {
      console.log(value.value);
      this.search = value.value;
      //this.circle_list_hot=[],
      (this.circletrends = []),
        (this.pageindex = 1),
        (this.flag = false),
        this.getCircle();
    },
    morelist() {
      // if (this.circletrends.length < this.pageindex) return this.flag = true
      if (!this.flag) {
        this.pageindex++;
        this.getCircle();
      }
    }
  },
  onShow() {
    (this.circle_list_hot = []),
      (this.circletrends = []),
      (this.pageindex = 1),
      (this.flag = false),
      this.getCircle();
    this.getCircleHot();
    this.$logindex();
  },

  onPullDownRefresh() {
    console.log("下拉刷新了");
    this.pageindex = 1;
    this.circletrends = [];
    this.flag = false;
    this.getCircle();
    setTimeout(() => {
      uni.stopPullDownRefresh();
    }, 1000);
  }
};
</script>

<style lang="less" scoped>
page {
  background-color: #ffffff;
}
.circleindex {
  @media (max-width: 991px) {
    width: 6.86rem;
    margin: 0.3rem auto;
    .container {
      padding: 0;
    }
  }
}
.kv {
  width: 100%;
  margin-bottom: 0.3rem;
  @media (max-width: 991px) {
    height: 2.6rem;
  }
  cursor: pointer;
  img {
    width: 100%;
  }
}
.circle_index {
  padding: 0 0rem 1.2rem 0rem;
  flex-direction: column;

  .circle_type {
    flex-wrap: wrap;
    justify-content: space-between;
    display: flex;

    .type_item {
      cursor: pointer;
      width: 3.7rem;
      height: 2.04rem;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      margin-bottom: 0.1rem;
      border-radius: 0.12rem;
      display: flex;
      @media (max-width: 991px) {
        width: 2.22rem;
        height: 1.6rem;
      }

      .type_title {
        font-size: 0.3rem;
        color: #ffffff;
        line-height: 0.42rem;
        margin-bottom: 0.08rem;
      }

      .type_desc {
        font-size: 0.24rem;

        color: #ffffff;
        line-height: 0.33rem;
        align-items: center;
        justify-content: center;
        .red {
          margin-left: 0.05rem;
          width: 0.3rem;
          height: 0.3rem;
        }
      }

      .type_btn_all {
        width: 1.17rem;
        height: 0.3rem;
        background: url(../../../static/circle/icon_7.png) no-repeat;
        background-size: 1.17rem 0.3rem;
      }
    }
  }
}

.add {
  position: fixed;
  bottom: 1.4rem;
  left: 50%;
  margin-left: -2.95rem;
  width: 5.9rem;
  height: 0.8rem;
  background: #1395ff;
  border-radius: 0.4rem;
  font-size: 0.3rem;
  color: #ffffff;
  line-height: 0.8rem;
  letter-spacing: 0.03rem;
  z-index: 2;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/view/circle/circle_index.vue